import api from './index'
import request from '@/utils/request'

/**
 * @description 创建分账纸质合同
 */
export function accredit (data) {
  return request({
    url: `${api.accredit}`,
    method: 'post',
    data
  })
}
/**
 * @description 创建分账电子合同
 */
export function elecContractAccredit (data) {
  return request({
    url: `${api.elecContractAccredit}`,
    method: 'post',
    data
  })
}
/**
 * @description 查询分账合同
 */
export function accreditQuery (data) {
  return request({
    url: `${api.accreditQuery}`,
    method: 'post',
    data
  })
}
/**
 * @description 分账绑定查询
 */
export function pageBind (data) {
  return request({
    url: `${api.pageBind}`,
    method: 'post',
    data
  })
}
/**
 * @description 关联收账方
 */
export function subAccountBind (data) {
  return request({
    url: `${api.subAccountBind}`,
    method: 'post',
    data
  })
}
/**
 * @description 取消关联收账方
 */
export function subAccountUnBind (data) {
  return request({
    url: `${api.subAccountUnBind}`,
    method: 'post',
    data
  })
}
/**
 * @description 付款记录
 */
export function pageSubAccount (data) {
  return request({
    url: `${api.pageSubAccount}`,
    method: 'post',
    data
  })
}
/**
 * @description 发起付款
 */
export function createSubAccount (data) {
  return request({
    url: `${api.createSubAccount}`,
    method: 'post',
    data
  })
}
/**
 * @description 撤销付款
 */
export function cancelSubAccount (data) {
  return request({
    url: `${api.cancelSubAccount}`,
    method: 'post',
    data
  })
}
/**
 * @description 收账记录
 */
export function pageIncome (data) {
  return request({
    url: `${api.pageIncome}`,
    method: 'post',
    data
  })
}
/**
 * @description 批量收款
 */
export function createBatchSubAccount (data) {
  return request({
    url: `${api.createBatchSubAccount}`,
    method: 'post',
    data
  })
}
/**
 * @description 导出付款列表
 */
export function exportSubAccount (data) {
  return request({
    url: `${api.exportSubAccount}`,
    method: 'post',
    data
  })
}
/**
 * @description 导出收款列表
 */
export function exportIncomes (data) {
  return request({
    url: `${api.exportIncomes}`,
    method: 'post',
    data
  })
}
